import styled from "styled-components";

interface IContainerListProps {
    filterAreaHeight: number;
}

export const ContainerListHeader = styled.div`
    background-color: #fafafa;
    display: flex;
    padding-right: 5px;
`;

export const ContainerList = styled.div<IContainerListProps>`
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: ${props => 45 - props.filterAreaHeight}vh;
    height: ${props => 45 - props.filterAreaHeight}vh;
    background-color: #fff;

    @media screen and (min-width: 700px) and (min-height: 1000px) {
        max-height: ${props => 65 - props.filterAreaHeight}vh;
        height: ${props => 65 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 800px) and (min-height: 1000px) {
        max-height: ${props => 70 - props.filterAreaHeight}vh;
        height: ${props => 70 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 700px) and (min-height: 900px) {
        max-height: ${props => 60 - props.filterAreaHeight}vh;
        height: ${props => 60 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1100px) and (min-height: 500px) {
        max-height: ${props => 55 - props.filterAreaHeight}vh;
        height: ${props => 55 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1100px) and (min-height: 700px) {
        max-height: ${props => 60 - props.filterAreaHeight}vh;
        height: ${props => 60 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1100px) and (min-height: 850px) {
        max-height: ${props => 80 - props.filterAreaHeight}vh;
        height: ${props => 80 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1100px) and (min-height: 900px) {
        max-height: ${props => 70 - props.filterAreaHeight}vh;
        height: ${props => 70 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1200px) and (min-height: 850px) {
        max-height: ${props => 58 - props.filterAreaHeight}vh;
        height: ${props => 58 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1300px) and (min-height: 850px) {
        max-height: ${props => 66 - props.filterAreaHeight}vh;
        height: ${props => 66 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1400px) and (min-height: 700px) {
        max-height: ${props => 60 - props.filterAreaHeight}vh;
        height: ${props => 60 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1400px) and (min-height: 800px) {
        max-height: ${props => 63 - props.filterAreaHeight}vh;
        height: ${props => 63 - props.filterAreaHeight}vh;
    }

    @media screen and (min-width: 1400px) and (min-height: 850px) {
        max-height: ${props => 66 - props.filterAreaHeight}vh;
        height: ${props => 66 - props.filterAreaHeight}vh;
    }

`

export const AccessButton = styled.a`
`;

export const CopyButton = styled.span`
    display: inline-flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    margin-right: 10px;
    cursor: pointer;
`;

export const OptionsLink = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
`;